<script setup>
/**
 * A main-screen section's title, with the button that folds the section away
 * (− ) and brings it back (+). The title stays when the section is hidden, so
 * there is always something to press. What sits beside the title is the
 * section's own (`extra`, left; default slot, right), and is only drawn while
 * the section is open: controls for a hidden chart are controls for nothing.
 */
import Icon from './Icon.vue'
import { isHidden, toggleSection } from '../../stores/sections'
import { t } from '../../stores/i18n'

const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
})
</script>

<template>
  <h2 class="section-title" :class="isHidden(props.id) ? '' : 'mb-2'" :data-section-title="props.id">
    <span class="flex min-w-0 items-center gap-1">
      {{ props.title }}
      <button
        class="btn-ghost -my-1 !px-1.5 !py-1"
        :aria-expanded="!isHidden(props.id)"
        :aria-label="isHidden(props.id) ? t('section.show', { name: props.title }) : t('section.hide', { name: props.title })"
        :title="isHidden(props.id) ? t('section.show', { name: props.title }) : t('section.hide', { name: props.title })"
        data-section-toggle
        @click="toggleSection(props.id)"
      >
        <Icon :name="isHidden(props.id) ? 'plus' : 'minus'" :size="14" />
      </button>
      <slot v-if="!isHidden(props.id)" name="extra" />
    </span>
    <slot v-if="!isHidden(props.id)" />
  </h2>
</template>
